export default __webpack_public_path__ + "img/46020e02bc9a1c4396d51f1fec8a4732.svg";